export default "Lav flotte perler og halskæder af hyld – men husk at spørge Hyldemor om lov, før I klipper hyldegrene!\n";